import { useSyncExternalStore } from "react";

export function pickFormattingLocale(appLanguage: string, navigatorLanguage: string, intlLocale: string): string {
    const region = regionOf(navigatorLanguage) ?? regionOf(intlLocale);

    return region ? new Intl.Locale(appLanguage, { region }).toString() : appLanguage;
}

function regionOf(locale: string): string | undefined {
    try {
        return new Intl.Locale(locale).region;
    } catch {
        return undefined;
    }
}

function getSnapshot(): string {
    return navigator.language;
}

function subscribe(onStoreChange: () => void) {
    window.addEventListener("languagechange", onStoreChange);

    return () => window.removeEventListener("languagechange", onStoreChange);
}

export function useFormattingLocale(appLanguage: string): string {
    const navigatorLanguage = useSyncExternalStore(subscribe, getSnapshot);

    return pickFormattingLocale(appLanguage, navigatorLanguage, new Intl.DateTimeFormat().resolvedOptions().locale);
}
